// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dksp","buttons":"styles_buttons__20cAQ"};